'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'face-thinking';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e39b';
var svgPathData = ['M16 256C16 123.5 123.5 16 256 16S496 123.5 496 256c0 124.8-95.3 227.4-217.1 238.9 5.8-11.7 9.1-24.9 9.1-38.9 0-48.6-39.4-88-88-88l-75.3 0c-10.4-36.9-44.4-64-84.7-64-6.4 0-12.7 .7-18.8 2-3.4-16.1-5.2-32.9-5.2-50zm89.1-124c2.2 3.8 7.1 5.2 10.9 3l13.1-7.5c23.7-13.5 53-12.5 75.7 2.6l30.9 20.6c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1l-30.9-20.6C185.8 98.3 150 97 121.1 113.6L108 121.1c-3.8 2.2-5.2 7.1-3 10.9zM152 328c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-112 0c-4.4 0-8 3.6-8 8zm8-120a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm160 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z', 'M278.9 494.9C400.7 483.4 496 380.8 496 256 496 123.5 388.5 16 256 16S16 123.5 16 256c0 17.1 1.8 33.9 5.2 50-5.3 1.2-10.4 2.8-15.3 4.8-3.9-17.7-5.9-36-5.9-54.9 0-141.4 114.6-256 256-256S512 114.6 512 256c0 137.3-108.1 249.4-243.9 255.7 4.2-5.1 7.9-10.8 10.8-16.8zM176 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm160 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM129 127.5L116 134.9c-3.8 2.2-8.7 .9-10.9-3s-.9-8.7 3-10.9l13.1-7.5c28.9-16.5 64.7-15.3 92.5 3.2l30.9 20.6c3.7 2.5 4.7 7.4 2.2 11.1s-7.4 4.7-11.1 2.2l-30.9-20.6c-22.7-15.1-52-16.1-75.7-2.6zM152 328c0-4.4 3.6-8 8-8l112 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-112 0c-4.4 0-8-3.6-8-8zM16 392l0 120c0 26.5 21.5 48 48 48l16 0c26.5 0 48-21.5 48-48l0-24c0-4.4 3.6-8 8-8l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-4.4 0-8-3.6-8-8l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24zm24-40c22.1 0 40 17.9 40 40l0 24 120 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0 0 16c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64L0 392c0-22.1 17.9-40 40-40z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceThinking = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;